export function generateHreflangLinks(
  fullPath: string,
  siteUrl: string,
  selectedLang: string,
  locales: any
) {
  const cleanPath = fullPath.startsWith(`/${selectedLang}`)
    ? fullPath.replace(`/${selectedLang}`, '')
    : fullPath;

  return locales
    .filter((loc: any) => loc.code !== selectedLang)
    .map((loc: any) => ({
      rel: 'alternate',
      hreflang: loc.code,
      href: `${siteUrl}${loc.prefix}${cleanPath}`,
    }));
}
